<app-protocolo-pesquisa
    [textoBotaoEnvio]="textoBotaoEnvio"
    [tooltipBotaoEnvio]="tooltipBotaoEnvio"
    [routerLinkEnvioLote]="['/operacoes/cadastro/lote']"
    [tiposConteudo]="tiposConteudo"

></app-protocolo-pesquisa>